import { mcn } from "@/utils/mergeClassNames";
import Link from "next/link";
import React from "react";
import ReactMarkdown from "react-markdown";

type Props = {
  className?: string;
  /**
   * Markdown formated content
   */
  content?: string;
  firstHeadingLevel?: 1 | 2 | 3;
};

type HeadingProps = React.PropsWithChildren<{
  level: number; // level in markdown input
  minLevel: number;
}>;
const Heading = (props: HeadingProps) => {
  const styleLevel = Math.min(props.level, 3); // We only support three levels, rest will be unstyled.
  const headingLevel = Math.min(props.level + props.minLevel - 1, 6);
  return React.createElement(
    `h${headingLevel}`,
    {
      className: `heading-${styleLevel}`,
    },
    props.children
  );
};

export const Markdown = ({
  content = "",
  className,
  firstHeadingLevel = 3,
}: Props) => {
  return (
    <div className={mcn("article", className)}>
      <ReactMarkdown
        components={{
          a: ({ children, href }) => <Link href={href ?? ""}>{children}</Link>,
          h1: (props) => <Heading minLevel={firstHeadingLevel} {...props} />,
          h2: (props) => <Heading minLevel={firstHeadingLevel} {...props} />,
          h3: (props) => <Heading minLevel={firstHeadingLevel} {...props} />,
          h4: (props) => <Heading minLevel={firstHeadingLevel} {...props} />,
          h5: (props) => <Heading minLevel={firstHeadingLevel} {...props} />,
          h6: (props) => <Heading minLevel={firstHeadingLevel} {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
